(function($) {
	formHelper.addRule({
		form: '.mwr-base-commission-form',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR: function(){
				alert("There were no results for your search or a processing error occurred");
			}
		}
	});
})(jQuery);


jQuery(function initToolsMwrBaseCommissionReport($) {
	$('.search-base-commission-form, .search-mwr-base-commission-results-form').each(function(index, el) {

		var $container = $(this);

		// Date confirmation Range
		// ------------------
		var $depDateStart = $('#departure-start-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var depDateStartPicker = $depDateStart.pickadate('picker');

		var $depDateEnd = $('#departure-end-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var depDateEndPicker = $depDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( depDateStartPicker.get('value') ) {
			depDateEndPicker.set('min', depDateStartPicker.get('select'));
		}
		
		if ( depDateEndPicker.get('value') ) {
			depDateStartPicker.set('max', depDateEndPicker.get('select'));
		}

		// When something is selected, update the "depDateStart" and "depDateEnd" limits.
		depDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				depDateEndPicker.set('min', depDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				depDateEndPicker.set('min', false);
			}
		});

		depDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				depDateStartPicker.set('max', depDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				depDateStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsMWRBaseCommissionResults($) {
	$('.search-mwr-base-commission-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-mwr-base-commission-report-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});